'use client';

import parse from 'html-react-parser';
import { FC } from 'react';

interface Props {
  html: string;
}

const BodyScripts: FC<Props> = ({ html }) => {
  return <>{parse(html)}</>;
};

export default BodyScripts;
